import React, { useState, useEffect, useRef, useContext } from 'react';
import 'react-multi-carousel/lib/styles.css';
import { DOC_ARRAY_AADHAR, DOC_ARRAY_PAN, DOC_COMPANY_GST } from '../documents/constant';
import UploadDocCard from './upload-doc-card';
import PreviewComponent from './preview-image';
import '../documents/document.scss';
import { deleteDocumentsForSummary, fetchOrder } from 'home/view/manage-feasibility/services';
import { getFromSessionStorage } from 'common/utils/app.utils';
import { DEFAULT_TOAST_MSG, ERROR_TOAST, MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN } from 'home/view/manage-feasibility/constants';
import { AppContext } from 'App';
//import PopupComponent from "../../../components/functional/pop-up/popup.component";
const UploadDocuments = (props) => {
  let {
    uploadedDoc = {},
    setUploadedDoc,
    selectedDocumentType,
    order,
    setSelectedOption,
    options,
    setCompanyGstValidation,
    setIsSaveBtnDisabled,
    fetchOrderFn,
    kdmImagePresent,
    kdmAccordionValidation
  } = props;
  const childRef = useRef();
  let documentArray = DOC_COMPANY_GST;
  const [showPopUp, setTogglePopUp] = useState(false);
  const [imageUrl, setPopupImageUrl] = useState('');
  const [sliderIndex, setSliderIndex] = useState(0);
  const { setToast } = useContext(AppContext);

  const [showAllDocUpload, setAllDocUpload] = useState(false);
  const [getOrderedImages, setOrderedImages] = useState([]);

  const summaryAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

  const deleteUploadedFile = async (documentName) => {
    const payload = { documentType: 'COMPANY', documentName };
    try {
      const { res, err } = await deleteDocumentsForSummary(payload, summaryAuthToken);
      if (res) {
        fetchOrderFn();
      }
    } catch (e) {
      const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;
      setToast(true, errorMsg, ERROR_TOAST);
      window.scrollTo(0, 0);
      console.error(e);
    }
  };

  const deleteAllImages = (props) => {
    const { doc1, doc2, doc3 } = props;
    deleteUploadedFile(doc1);
    deleteUploadedFile(doc2);
    deleteUploadedFile(doc3);
    setUploadedDoc({});
    // setCompanyGstValidation(false);
    setIsSaveBtnDisabled(true);
  };

  const onSuccessCb = (order) => {};

  const clearAllImages = () => {
    deleteAllImages({ doc1: 'GST_CERTIFICATE', doc2: 'GST_ANNEXURE_A', doc3: 'GST_ANNEXURE_B' });
  };

  const togglePopUp = (keyName) => {
    Object.keys(uploadedDoc).forEach((key) => {
      if (key === keyName) {
        setPopupImageUrl(uploadedDoc[key]);
        setTogglePopUp(!showPopUp);
      }
    });
  };

  useEffect(() => {
    let sliderCurrentIndex = childRef && childRef.current && childRef.current.state && childRef.current.state.currentSlide ? childRef.current.state.currentSlide : 0;
    if (sliderIndex > 0 && sliderCurrentIndex < Object.keys(documentArray).length - 1) {
      if (sliderCurrentIndex < Object.keys(documentArray).length - 2) {
        childRef && childRef.current && childRef.current.goToSlide(sliderCurrentIndex + 1, true);
      }
    }
  }, [sliderIndex]);

  useEffect(() => {
    // console.log(order, 'order');
    const authSignDocs = order?.documents?.COMPANY;
    const obj = {};
    if (order?.documents?.COMPANY) {
      authSignDocs &&
        Object.keys(authSignDocs).forEach((item) => {
          if (item !== 'KDM') {
            obj[item] = authSignDocs[item];
          }
        });
      setUploadedDoc(obj);
    }
  }, []);
  const renderDocCards = () =>
    Object.keys(documentArray).map((keyName, index) => (
      <UploadDocCard
        kdmImagePresent={kdmImagePresent}
        fetchOrderFn={fetchOrderFn}
        setCompanyGstValidation={setCompanyGstValidation}
        setIsSaveBtnDisabled={setIsSaveBtnDisabled}
        order={order}
        documentObj={documentArray}
        keyName={keyName}
        key={index}
        setAllDocUpload={setAllDocUpload}
        showAllDocUpload={showAllDocUpload}
        uploadedDoc={uploadedDoc}
        setUploadedDoc={setUploadedDoc}
        togglePopUp={togglePopUp}
        getOrderedImages={getOrderedImages}
        setSliderIndex={setSliderIndex}
        sliderIndex={sliderIndex}
        kdmAccordionValidation={kdmAccordionValidation}
      />
    ));
  return (
    <React.Fragment>
      <div className="doc-upload-area">
        {showPopUp && <PreviewComponent imageUrl={imageUrl} togglePopUp={togglePopUp} uploadedDoc={uploadedDoc} />}
        <div className="slides-indicator">
          <div className="doc-info">
            <div className="info">
              {documentArray && uploadedDoc && Object.keys(uploadedDoc).length > 0 && Object.keys(uploadedDoc).length !== Object.keys(documentArray).length && (
                <span className="text-success text-red">
                  {' '}
                  {Object.keys(uploadedDoc).filter((key) => key !== 'KDM').length} of {Object.keys(documentArray).length} documents uploaded.
                </span>
              )}
              <p className="upload-info-text">*The maximum file upload size is 5MB. File format should be either .PNG, .JPG, or .JPEG.</p>
            </div>
            {documentArray && uploadedDoc && Object.keys(uploadedDoc).filter((key) => key !== 'KDM').length === Object.keys(documentArray).length && (
              <div className="clear" onClick={clearAllImages} style={{ fontSize: '14px' }}>
                Clear All
              </div>
            )}
          </div>
        </div>
        <div className="document_carousel">
          <div className="carousel-control-new">
            <div className="doc_items">{renderDocCards()}</div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

UploadDocuments.defaultProps = {
  moEngageKey: {}
};

export default UploadDocuments;
